export const version = '1.2.6';
//# sourceMappingURL=version.js.map